// src/utils/decrypt.js
export const decryptFile = (encryptedContent, secretKey) => {
  try {
    const decoded = atob(encryptedContent);

    return decoded
      .split("")
      .map((char, index) =>
        String.fromCharCode(
          char.charCodeAt(0) ^ secretKey.charCodeAt(index % secretKey.length)
        )
      )
      .join("");
  } catch (error) {
    console.error("Error al desencriptar:", error);
    return null;
  }
};
